module.exports = __webpack_public_path__ + "media/img/pages/companies/j-w-64ec935d6c34abe88931622d0e80aa1c.jpg";